import { Tooltip, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";

import Highlight from "../../../Highlight";

const TruncatedText = ({
  text,
  tooltipDisabled = false,
  style,
  searchedTerm = "",
  disablePortal = true,
}: {
  text: string;
  tooltipDisabled?: boolean;
  style?: any;
  searchedTerm?: string;
  disablePortal?: boolean;
}) => {
  const textRef = useRef<HTMLDivElement | null>(null);
  const [isOverflowed, setIsOverflowed] = useState(false);

  useEffect(() => {
    if (!tooltipDisabled) {
      const el = textRef.current;
      if (!el) return;

      // Check for overflow
      const isOverflow = el.scrollWidth > el.clientWidth;
      setIsOverflowed(isOverflow);
    }
  }, [text, tooltipDisabled]);

  return (
    <Tooltip
      title={isOverflowed ? text : ""}
      disableInteractive
      arrow
      disableHoverListener={!isOverflowed}
      slotProps={{
        popper: {
          modifiers: [
            {
              name: "preventOverflow",
              options: {
                boundary: "scrollParent",
              },
            },
          ],
          disablePortal: disablePortal,
        },
      }}
    >
      <Typography
        ref={textRef}
        sx={
          style
            ? style
            : {
                fontFamily: "Roboto",
                fontWeight: 400,
                fontSize: "13px",
                lineHeight: "18px",
                color: "rgba(0,0,0,0.87)",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                maxWidth: "100%",
                marginLeft: "8px",
              }
        }
      >
        <Highlight value={text} searchText={searchedTerm} />
      </Typography>
    </Tooltip>
  );
};

export default TruncatedText;
